import { NAMESPACE_INTERESTING_MATCHES } from 'app/constants/Context';
import createSelectors from 'app/redux/betting-presentation/grid/selectors';

import * as entityGridSelectors from './entities';

export const {
  stakeLayout,
  stakeTypeGroupBySportId,
  gridSubheaderBreadcrumbSelector,
  tournamentsGroupedByPromotionLevelBySportIdsSortingByPrioritySelector,
  createVisibleStakeTypeGroupIdsSelector,
  mainLineId,
  visibleLineStakeIdsSelector,
} = createSelectors(NAMESPACE_INTERESTING_MATCHES, entityGridSelectors, { path: ['grid'] });
